import React from 'react';
import {
  RestaurantDetails_getRestaurantDetails_owner_claims,
  RestaurantInfoModalOverview_getRestaurantDetails,
  RestaurantDetails_getRestaurantDetails_operatingStatus
} from '../../../../../types/graphql-types-generated.ts';
import { SiblingRestaurant } from '../../00-atoms/sibling-restaurant/sibling-restaurant.tsx';
import { useHiddenScrollbar } from '../../../../../patterns/01-molecules/hidden-scrollbar/hidden-scrollbar.tsx';
import { Cookie } from '../../../../../utils/cookie.ts';
import { classList } from '../../../../../utils/string.ts';

export type SiblingRestaurantsProps = {
  details: RestaurantInfoModalOverview_getRestaurantDetails;
  siblings: RestaurantDetails_getRestaurantDetails_owner_claims[];
};

const siblingRestaurant = (
  sibling: RestaurantDetails_getRestaurantDetails_owner_claims & {
    averageReviewScore: number;
    reviewsCount: number;
    cuisineTranslations: { name: string; urlKey: string }[] | null;
    linkedCity: { fullnameLower: string };
    operatingStatus: RestaurantDetails_getRestaurantDetails_operatingStatus | null;
  }
) => <SiblingRestaurant key={sibling.id} sibling={sibling} />;

export const SiblingRestaurants: React.FunctionComponent<SiblingRestaurantsProps> = props => {
  const hiddenScrollbar = useHiddenScrollbar({
    renderArrows: true,
    renderDots: 'none',
    scrollRange: 'elementWise',
    scrollRotation: false,
    startAtSlide: 0,
    containerType: 'div',
    className: 'flex snap-x overflow-y-scroll pb-7 [&::-webkit-scrollbar]:h-0',
    children: <>{props.siblings.map(siblingRestaurant)}</>
  });
  const abTabSetup = new Cookie('sk-AB-tabsetup').value ?? 0;

  return (
    <div
      className={classList(
        'text-sk-dark-blue bg-white',
        abTabSetup !== '4' && 'border-sk-grey-200 border-t-4',
        'pt-8 pb-1'
      )}
    >
      <div className="mx-4 mb-4 text-2xl/8 font-extrabold">Auch von uns</div>
      {hiddenScrollbar.mainElement}
    </div>
  );
};
